import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { removeLocaleFromUrl } from '@/utils/locale/removeLocaleFromUrl';

export const useCurrentPath = () => {
    const searchParams = useSearchParams();
    const nextPathname = usePathname();

    const pathname = removeLocaleFromUrl(nextPathname);

    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        if (nextPathname !== null) {
            setIsReady(true);
        }
    }, [nextPathname]);

    const asPath = `${pathname}${
        searchParams && searchParams.toString().length
            ? `?${decodeURIComponent(searchParams.toString())}`
            : ''
    }`;

    return { pathname, searchParams, asPath, isReady };
};
